import React, { useState, useEffect } from "react";
import { MdOutlineNotifications , MdNotificationsActive } from "react-icons/md";
import { useSubscriptionStore } from "./subscriptionStore";
import { FormattedEvent } from "../../../types";
import "./EventSubscription.css";

let notificationPermissionAsked = false;

function getClientId(): string {
  let id = localStorage.getItem("clientId");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("clientId", id);
  }
  return id;
}

interface EventSubscriptionProps {
  event: FormattedEvent;
}

const EventSubscription: React.FC<EventSubscriptionProps> = ({ event }) => {
  const getSubscription = useSubscriptionStore((s: any) => s.getSubscription);
  const subscribeEvent = useSubscriptionStore((s: any) => s.subscribeEvent);
  const unsubscribeEvent = useSubscriptionStore((s: any) => s.unsubscribeEvent);
  const [subscribed, setSubscribed] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [loading, setLoading] = useState(false);
  const clientId = getClientId();

  useEffect(() => {
    const fetchSubscription = async () => {
      setLoading(true);
      let mounted = true;
      try {
        const res = await getSubscription(clientId, event.hash_id);
        if (mounted) setSubscribed(res);
      } finally {
        if (mounted) setLoading(false);
      }
      return () => {
        mounted = false;
      };
    };
    fetchSubscription();
  }, [clientId, event.title]);

  const handleClick = async () => {
    if(updating || loading){
      return
    }
    setUpdating(true);
    try {
      let result = false
      if (!subscribed) {
        if (!notificationPermissionAsked) {
          const permission = await Notification.requestPermission();
          notificationPermissionAsked = true;
          if (permission !== "granted") {
            alert("Notifications are disabled. Cannot subscribe.");
            setUpdating(false);
            return;
          }
        }

        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,
        }); 
        result = await subscribeEvent(clientId, event.hash_id, subscription.toJSON());
      } else {
        result = await unsubscribeEvent(clientId, event.hash_id);
      }
      setSubscribed(result)
    } catch (err) {
      console.error("Subscription toggle failed", err);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <a className="event-subscription"
      onClick={handleClick}
      aria-label={subscribed ? "Unsubscribe from event" : "Subscribe to event"}
    >
      <span className={updating ? "pulse" : ""}>
        { loading || !subscribed ? <MdOutlineNotifications /> : <MdNotificationsActive />}
      </span>
    </a>
  );
};

export default EventSubscription;